import { useTranslation } from 'react-i18next';
// material
import { enUS,svSE , deDE, daDK, nbNO, fiFI} from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'Danish',
    value: 'dk',
    systemValue: daDK,
    icon: '/static/icons/ic_flag_dk.svg'
  },
  {
    label: 'Norwegian',
    value: 'no',
    systemValue: nbNO,
    icon: '/static/icons/ic_flag_no.svg'
  },
  {
    label: 'Swedish',
    value: 'sv',
    systemValue: svSE,
    icon: '/static/icons/ic_flag_sv.svg'
  },
  {
    label: 'Finnish',
    value: 'fi',
    systemValue: fiFI,
    icon: '/static/icons/ic_flag_fi.svg'
  },
  {
    label: 'German',
    value: 'de',
    systemValue: deDE,
    icon: '/static/icons/ic_flag_de.svg'
  }
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
